import React from "react";
import ContractView from "../CustomComponents/ContractView";

export default function LegalContractPage({ type }) {
  return (
    <div className="container py-5">
      <ContractView type={type} />
    </div>
  );
}
